/**
 * Home2 FAQ Section
 * Collapsible FAQ accordion.
 * 
 * @module components/home2/Home2FAQ
 */

import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
import { FAQ_DATA } from '../../data/home2Content';

const Home2FAQ = () => {
  const [sectionExpanded, setSectionExpanded] = useState(false);
  const [expandedFaqs, setExpandedFaqs] = useState({});

  const toggleFaq = (index) => {
    setExpandedFaqs(prev => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <section className="container mx-auto px-4 py-12">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => setSectionExpanded(!sectionExpanded)}
          className="w-full bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-all text-left"
          aria-expanded={sectionExpanded}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-slate-100 rounded-lg">
                <HelpCircle className="h-6 w-6 text-slate-600" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-slate-900 mb-1">
                  Frequently Asked Questions
                </h2>
                <p className="text-sm text-slate-500">
                  {FAQ_DATA.length} questions answered
                </p>
              </div>
            </div>
            {sectionExpanded ? (
              <ChevronUp className="h-6 w-6 text-slate-400 flex-shrink-0" />
            ) : (
              <ChevronDown className="h-6 w-6 text-slate-400 flex-shrink-0" />
            )}
          </div>
        </button>
        
        {sectionExpanded && (
          <div className="mt-4 space-y-2">
            {FAQ_DATA.map((faq, index) => (
              <div key={index} className="bg-white border border-slate-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between p-4 text-left hover:bg-slate-50 transition-colors"
                  aria-expanded={expandedFaqs[index]}
                >
                  <span className="font-medium text-slate-900 pr-4">{faq.question}</span>
                  {expandedFaqs[index] ? (
                    <ChevronUp className="h-5 w-5 text-slate-400 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="h-5 w-5 text-slate-400 flex-shrink-0" />
                  )}
                </button>
                {expandedFaqs[index] && (
                  <div className="px-4 pb-4">
                    <p className="text-slate-600 text-sm leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Home2FAQ;
